export default "__VITE_ASSET__BLGBr5R9__"